(function () {
    'use strict';

    angular.module("imApp").factory("custactComplaintService", ['$ihttp', function ($ihttp) {
        var service = {
            getCustactComplaint: function (parms) {
                return $ihttp.post({
                    method: 2776,
                    parameters: parms || {}
                });
            },
            createObj: function (setting) {
                return $ihttp.post({
                    method: 2777,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();